import { useQuery } from '@tanstack/react-query';
import { LocationPractitioner, LocationsApi } from '~/api';
import { getBaseUrl } from '~/env';

export function useLocationPractitioners(clinicLocationGuid: string) {
  const queryResults = useQuery<LocationPractitioner[]>({
    queryKey: ['location-practitioner', clinicLocationGuid],
    queryFn: async () => {
      const api = new LocationsApi({ baseUrl: getBaseUrl() });
      const response = await api.getPractitionerAtLocation(clinicLocationGuid);
      const data = await response.json();
      return data.practitioners || [];
    },
  });

  return queryResults;
}
